module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBold.ba5cde21.ttf";